import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Image Columns",
  tags: ["#page"],
}

export default defineBlock("content/image-columns", (props) => {
  const images = props.images || []
  const breakout = !env.admin && images.length > 2

  return (
    <div
      className={cn(
        "content-sized my-8 grid grid-cols-1 gap-8 md:gap-4",
        props.condensedWidth && "md:w-3/5",
        images.length === 2 && "md:grid-cols-2",
        images.length === 3 && "md:grid-cols-3",
        images.length === 4 && "md:grid-cols-4",
        breakout &&
          "md:w-[100vw] md:-ml-[calc((100vw-var(--size-termsMaxW))/2)] md:!max-w-none md:px-[calc(var(--tw-grid-col-width)*2+var(--tw-grid-gutter)*1)]",
      )}
    >
      {images.length === 0 && env.admin && (
        <div className="w-full p-5 bg-slate300 flex items-center justify-center text-slate950 type-sans-base-regular">
          No images added. Please add images to display here.
        </div>
      )}
      {images.map((image, index) => {
        const delay = index * 100
        const ImageEl = image?.link?.url ? Link : "div"
        const imageProps = image?.link?.url
          ? {
              href: image.link.url,
              target: image.link.target || undefined,
              className: "w-full",
            }
          : {}

        return (
          !!image && (
            <div key={index} className="w-full flex flex-col gap-3 md:gap-3">
              <ImageEl {...imageProps}>
                <Appear delay={delay} className="w-full p-6 rounded-md bg-slate200">
                  <ResponsiveImage {...image.image} className="w-full h-auto" />
                </Appear>
              </ImageEl>
              {image.caption && (
                <Appear delay={delay + 100} className="w-full mt-4 type-sans-sm-regular text-slate600">
                  <div className="[&_a]:underline" dangerouslySetInnerHTML={{ __html: image.caption }} />
                </Appear>
              )}
            </div>
          )
        )
      })}
    </div>
  )
})
